// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeIndicatorSupportingDocumentsPage_wrapper__as02k"};